import { render, staticRenderFns } from "./Atalhos.vue?vue&type=template&id=1bafd421&scoped=true&"
import script from "./Atalhos.vue?vue&type=script&lang=js&"
export * from "./Atalhos.vue?vue&type=script&lang=js&"
import style0 from "./Atalhos.vue?vue&type=style&index=0&id=1bafd421&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bafd421",
  null
  
)

export default component.exports